import { ca } from '@cian/analytics';

type TTrackAddressClickParams = {
  label: string;
  withDistance?: boolean;
  geoType?: string;
};

export function trackAddressClick({ label, withDistance = false, geoType }: TTrackAddressClickParams) {
  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'click_address',
    label,
  });

  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'click_geo_link',
    label: 'description',
    useLastProducts: true,
    page: {
      extra: {
        geo_type: withDistance ? label : geoType || '',
        with_distance: withDistance,
      },
    },
  });
}
